/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconBuyMoreCart = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      width={size}
      height={size}
      {...rest}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 17H6V3H4M19 13H6M11.5 3.897v5M14 6.397H9" />
      <path fill="currentColor" d="M19.455 2.462V10h-1.411V3.907l-1.68 1.02-.628-.964 2.453-1.5h1.266Z" />
    </svg>
  );
};
export default IconBuyMoreCart;
